import Vue from 'vue';
import Router from 'vue-router';
import store from "@/store/store";
import valiLogin from "../../api/login";
import config from '../../api/config';
/*  默认UI组件 */
import login from '@/components/login';//登录页
import index from '@/components/index';//首页
import appdl from '@/components/appdl';//APP下载页
import colle from '@/components/colle';//回收站页

/*  移动端WEB */


/*  载入语言 */
import '@/i18n/langs/langs.js'

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        // 默认是登录页面
        {
            path: '/' || '/login',
            name: 'login',
            component: login,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/index',
            name: 'index',
            component: index,
            query: {
                vpath: '/',
                vmode: 1
            },
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/appdl',
            name: 'appdl',
            component: appdl
        },
        {
            path: '/colle',
            name: 'colle',
            component: colle,
            query: {
                vpath: '/',
                vmode: 3
            },
            meta: {
                requireAuth: true
            }
        }
    ]
});

// 设置路由拦截器

router.beforeEach((to, from, next) => {
    const jwt = window.localStorage.getItem("token");
    if (jwt == '' || jwt == 'undefined' || jwt == null || jwt == 'NULL' || typeof(jwt) !== 'string') {
        next({name: login});
        return;
    }
    try {
        const token = JSON.parse(jwt);// {"value":"84370A7C70292D43CFF4CFED8765FFB2","expire":1603938571}
        if ((typeof token).toLowerCase() == 'object' && token.hasOwnProperty('value')) {
            
            const username = localStorage.getItem('username');
            const nationcode = isNaN(store.state.nation.code) ? 86 : store.state.nation.code;
            const postData = {
                username: username,
                nationcode: nationcode,
                token: token.value
            };
            $.ajax({
                method: 'post',
                url: config + '/?r=v1/login/vali-login',
                data: postData,
                headers: {
                    "X-Requested-With": "XMLHttpRequest"
                },
                success: function (res) {
                    if (res && res.error == 0) {
                        next();
                    } else {
                        next({name: login});
                        return;
                    }
                },
                error: function (err) {
                    next({name: login});
                    return;
                }
            });
        } else {
            next({name: login});
            return;
        }
    } catch (err) {
        next({name: login});
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js